export default {
  footer: {
    usefulLinks: 'Top classes and experiences near you',
  },
}
